import { filter, flatten, has, pipe, pluck, identity } from 'ramda'

const selectManifestEntriesOfType = (type) =>
  pipe(flatten, filter(has(type)), pluck(type), filter(identity))

export const getDeclaredApplications =
  selectManifestEntriesOfType('application')

export const getDeclaredPlugins = selectManifestEntriesOfType('plugin')
